import React from "react";
import {FormattedMessage} from "react-intl";
import "./TopicDescriptionCreation.css";
import {FileUpload} from "../../../reusables/FileUpload";
import {NavigationManagement} from "../../LandingPage";
import API from "../../../logic/API";

/**
 * Controls the upload section when viewing topic descriptions with upload transfer type.
 */
function UploadSection(props: {
  alternative: "create" | "view" | "edit";
  navigationManagement: NavigationManagement;
  topicId: string;
  disabledReason?: "inactive" | "unauthorized";
}) {
  return (
    <>
      <h2>{<FormattedMessage id="topicDescriptionCreation.h2.upload" />}</h2>
      <FileUpload
        navigationManagement={props.navigationManagement}
        allowMultiple={false}
        uploadFile={API.uploadFileToTopic}
        uploadToTopicWithId={props.topicId}
        isDisabled={
          props.disabledReason ? (
            <FormattedMessage
              id={"topicDescriptionCreation.upload." + props.disabledReason}
            />
          ) : undefined
        }
      />
    </>
  );
}

/**
 * Controls the transfer section when viewing topic descriptions with upload transfer type.
 */
function UploadTransferSection(props: {
  alternative: "create" | "view" | "edit";
}) {
  if (props.alternative !== "create") return null;
  return (
    <>
      <div className="topicDescriptionCreationUploadInfo">
        <FormattedMessage id="topicDescriptionCreation.upload.information" />
      </div>
    </>
  );
}

export {UploadSection, UploadTransferSection};
